import { useSettings } from "@/libs/hooks/useSettings";
import { useMainDict } from "@/libs/hooks/useTranslation";
import Image from "next/image";

export const DeliveryLinksComponent = () => {
  const { settings } = useSettings();
  const { t } = useMainDict();

  const hasDeliveryLinks = settings?.showWolt || settings?.showGlovo ||
    settings?.showBolt || settings?.showUber || settings?.showPyszne;

  if (!hasDeliveryLinks) return null;

  return (
    <div className="mt-8 w-full">
      {/* Vintage styled header */}
      <div className="relative mb-6">
        <h2 className="font-condensed text-vintage-ochre text-center text-2xl md:text-3xl tracking-[0.2em] uppercase">
          {t("orderNow")}
        </h2>
        {/* Decorative underline */}
        <div className="flex items-center justify-center gap-2 mt-2">
          <div className="w-8 h-px bg-vintage-ochre/40" />
          <div className="w-2 h-2 rotate-45 border border-vintage-ochre/40" />
          <div className="w-8 h-px bg-vintage-ochre/40" />
        </div>
      </div>

      {/* Delivery links in vintage card style */}
      <div className="flex flex-wrap justify-center gap-3">
        {settings?.showWolt && settings.woltLink && (
          <a
            target="_blank"
            aria-label="Order on Wolt"
            href={settings.woltLink}
            className="group relative bg-vintage-cream border border-vintage-walnut/20 rounded-lg p-3
              shadow-vintage-sm hover:shadow-vintage transition-all duration-300
              hover:-translate-y-1"
          >
            <Image src="/wolt.png" height={40} width={60} alt="Order on Wolt" className="opacity-90 group-hover:opacity-100 transition-opacity" />
          </a>
        )}

        {settings?.showGlovo && settings.glovoLink && (
          <a
            target="_blank"
            aria-label="Order on Glovo"
            href={settings.glovoLink}
            className="group relative bg-vintage-cream border border-vintage-walnut/20 rounded-lg p-3
              shadow-vintage-sm hover:shadow-vintage transition-all duration-300
              hover:-translate-y-1"
          >
            <Image src="/glovo.png" height={40} width={80} alt="Order on Glovo" className="opacity-90 group-hover:opacity-100 transition-opacity" />
          </a>
        )}

        {settings?.showBolt && settings.boltLink && (
          <a
            target="_blank"
            aria-label="Order on Bolt"
            href={settings.boltLink}
            className="group relative bg-vintage-cream border border-vintage-walnut/20 rounded-lg p-3
              shadow-vintage-sm hover:shadow-vintage transition-all duration-300
              hover:-translate-y-1"
          >
            <Image src="/bolt.png" height={50} width={90} alt="Order on Bolt" className="opacity-90 group-hover:opacity-100 transition-opacity" />
          </a>
        )}

        {settings?.showUber && settings.uberLink && (
          <a
            target="_blank"
            aria-label="Order on Uber Eats"
            href={settings.uberLink}
            className="group relative bg-vintage-cream border border-vintage-walnut/20 rounded-lg p-3
              shadow-vintage-sm hover:shadow-vintage transition-all duration-300
              hover:-translate-y-1"
          >
            <Image src="/uber.png" height={50} width={90} alt="Order on Uber Eats" className="opacity-90 group-hover:opacity-100 transition-opacity" />
          </a>
        )}

        {settings?.showPyszne && settings.pyszneLink && (
          <a
            target="_blank"
            aria-label="Order on Pyszne"
            href={settings.pyszneLink}
            className="group relative bg-vintage-cream border border-vintage-walnut/20 rounded-lg p-3
              shadow-vintage-sm hover:shadow-vintage transition-all duration-300
              hover:-translate-y-1"
          >
            <Image src="/pyszne.png" height={50} width={90} alt="Order on Pyszne" className="opacity-90 group-hover:opacity-100 transition-opacity" />
          </a>
        )}
      </div>
    </div>
  );
};
